import styled from 'styled-components'
import { AutomationId, AUTO_ATTR_KEY } from 'utils/automationUtil'

interface StyledHeaderWidgetProps {
  displayTheme: string
}

const StyledHeaderWidget = styled.div.attrs({
  [AUTO_ATTR_KEY]: AutomationId.header
})<StyledHeaderWidgetProps>`
  font-family: var(--large-font-family);
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  font-size: 28px;
  line-height: 36px;
  font-weight: 400;
  padding-bottom: 8px;
  box-sizing: border-box;
  box-shadow: inset 0 -1px 0 0 ${({ displayTheme }) => (displayTheme === 'dark' ? '#C7CCD1' : '#7B8790')};
`

export default StyledHeaderWidget
